import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select'
import { useAuthState } from "../../Helper/Context";

export const WardNameDDL = (props) => {
    const { WardNameID, setWardNameID, Flag, data, IsPost, Language, StarMark, ApiFlag,ZoneNameID } = props

    const { t } = useTranslation()

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    useEffect(() => {
        const data = {
            M_ZoneID :ZoneNameID.ID ,
            M_UserID: UserID,
            Flag : ApiFlag,        
            Lanaguage: Language?.Label ,
            token: token
        }
        // { Language?.Label != null && dispatch(WardNameDDLAPI({ data })) }
    }, [IsPost, Language?.Label,ZoneNameID.ID])

    const { DDLData } = useSelector(state => state.WardNameDDLData)

    useEffect(() => {
        handleDDL()
    }, [DDLData])

    const handleDDL = () => {
        if (DDLData && DDLData.table && DDLData.table.length > 0) {
            let list = DDLData.table.map((item, index) => ({
                value: item.m_WardID,
                label: item.wardName,
            }))

            setWardNameID({
                DDL: list,
                ID: Flag == 'Update' ? data?.m_WardID : 0,
                Label: Flag == 'Update' ? data?.wardName : "Select...",
            })
        }
        else {
            setWardNameID({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }
    return (
        <div className="form-group">
            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.WardName')} </label>
            <Select
                id='WardNameID'
                isClearable={false}
                // isRtl={isRtl}
                isSearchable
                maxMenuHeight={130}
                value={{ value: WardNameID?.ID, label: WardNameID?.Label }}
                onChange={(e) => {
                    e ?
                        setWardNameID({ ...WardNameID, ID: e.value, Label: e.label })
                        :
                        setWardNameID({ ...WardNameID, ID: 0, Label: "Select..." })

                }}
                options={WardNameID?.DDL}
            />
        </div>
    )
}